import React from "react";
import { Button } from "@/components/ui/button";
import { DropdownMenu } from "@/components/ui/dropdown-menu";
import { ChevronDown, Download, FileSpreadsheet, FileText } from "lucide-react";

type ReputationExportMenuProps = {
  label: string;
  isExporting: boolean;
  disabled?: boolean;
  onExport: (format: "xlsx" | "csv") => void;
};

export function ReputationExportMenu({ label, isExporting, disabled, onExport }: ReputationExportMenuProps) {
  const isDisabled = disabled || isExporting;

  return (
    <DropdownMenu
      renderTrigger={triggerProps => (
        <Button
          {...triggerProps}
          variant="outline"
          disabled={isDisabled}
          title={label}
          aria-label={label}
          className="h-9 w-9 shrink-0 gap-2 bg-white px-0 md:w-auto md:px-4"
        >
          <Download className="size-4" />
          <span className="hidden md:inline">{isExporting ? "Exporting..." : label}</span>
          <ChevronDown className="hidden size-3.5 opacity-60 md:inline" />
        </Button>
      )}
      items={[
        {
          id: "xlsx",
          label: "Export to Excel",
          icon: <FileSpreadsheet className="size-4" />,
          disabled: isDisabled,
          onClick: () => onExport("xlsx"),
        },
        {
          id: "csv",
          label: "Export to CSV",
          icon: <FileText className="size-4" />,
          disabled: isDisabled,
          onClick: () => onExport("csv"),
        },
      ]}
    />
  );
}
